module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contentMenu"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "contentMenu__list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', [_c('router-link', {
      staticClass: "contentMenu__item",
      attrs: {
        "to": '/' + item
      }
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d6916b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contentMenu.vue
// module id = 77
// module chunks = 0